module.exports = __webpack_public_path__ + "static/media/portugal_flag.8ce156e0.svg";